import type { FaireProductEntity } from "../../entity_types/product";

export const p_6g2k946gcc: FaireProductEntity = {
  token: "p_6g2k946gcc",
  type: "product",
  name: "Boon Chips",
  brandToken: "b_qh7ymfdb7c",
  brandName: "Boon",
  imageUrl:
    "https://cdn.faire.com/fastly/5294a407dde6c2c995cd4e7184965583a38015bb3f3d25434b871c901d466aa4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48bf5b8c7171a9eb3c95f17c4381c097576e49d88f8a2191a0da493caaf30eb5.png",
    "https://cdn.faire.com/fastly/895e4c7a609ee7d29d457b4fd6903ebd11a6baefe8b804579e75c16efc0e9c1f.png",
  ],
  priceDollars: 3.5,
  description:
    "Crafted from thick-cut Kennebec potatoes and kettle-cooked to a golden crunch, these chips are dusted with a chili spice blend born from our signature Boon Sauce. Each bite is spicy, balanced, and full of depth and delivers the bold flavor of chili, garlic, and umami. Consider this your new favorite crunchy snack with a serious kick.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:19.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
